import { ManagerProgressionTaskState, Sport } from '__generated__/globalTypes';
import { useConfigContext } from 'contexts/config';
import { useCurrentUserContext } from 'contexts/currentUser';
import { useSportContext } from 'contexts/sport';
import { useLifecycle } from 'hooks/useLifecycle';

export const useUnclaimedMarketTasksCount = () => {
  const { sport } = useSportContext();
  const { currentUser } = useCurrentUserContext();
  const { lifecycle } = useLifecycle();
  const { tasks } = useConfigContext();

  const claimableTasksCount =
    tasks?.filter(t => t.aasmState === ManagerProgressionTaskState.COMPLETED)
      ?.length || 0;

  const isCommonGameOnboarded = () => {
    if (sport === Sport.NBA || sport === Sport.FOOTBALL) {
      return !!currentUser?.anyUserSportProfile?.commonGameOnboarded;
    }
    return false;
  };

  return isCommonGameOnboarded() && !lifecycle?.hideCommonFeatures
    ? claimableTasksCount
    : 0;
};
